import { Reducer } from 'redux';

import { WebhooksState } from './types';

const defaultState = {
    loadingWebhooks: false,
    loadingSingleWebhook: false,
};

const reducer: Reducer<WebhooksState> = (state: WebhooksState = defaultState, action): WebhooksState => {
    const { payload, type } = action;
    switch (type) {
        case '@@webhooks/LOAD_WEBHOOKS':
            return { ...state, loadingWebhooks: true };
        case '@@webhooks/UPDATE_WEBHOOKS_SUCCESS':
        case '@@webhooks/LOAD_WEBHOOKS_SUCCESS':
            return { ...state, loadingWebhooks: false, webhooks: payload.webhooks };
        case '@@webhooks/ERROR':
            return { ...state, loadingWebhooks: false };
        case '@@webhooks/SET_SINGLE_WEBHOOK':
            return { ...state, singleWebhook: payload.singleWebhook };
        case '@@webhooks/CLEAR_SINGLE_WEBHOOK':
            return { ...state, singleWebhook: null, errors: null };
        case '@@webhooks/VALIDATE_INPUT_ERROR':
            return { ...state, errors: payload.errors };
        case '@@webhooks/SET_EDITED_VALUES':
        case '@@webhooks/SET_EDITED_VALUES_SUCCESS':
            return { ...state, loadingSingleWebhook: payload.loadingSingleWebhook };
        default:
            return state;
    }
};

export { reducer as webhooks };

export default reducer;
